/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Fine_ArtInputs */

const en_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine Art`)
};

const es_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bellas artes`)
};

const fr_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beaux-arts`)
};

const de_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunstfotografie`)
};

const ja_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファインアート`)
};

const zh_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`艺术摄影`)
};

const ar_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فنون جميلة`)
};

const id_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seni Rupa`)
};

const it_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia d'Arte`)
};

const ru_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Художественная`)
};

const pt_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belas Artes`)
};

const ko_val_fine_art = /** @type {(inputs: Val_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파인 아트`)
};

/**
* | output |
* | --- |
* | "Fine Art" |
*
* @param {Val_Fine_ArtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_fine_art = /** @type {((inputs?: Val_Fine_ArtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Fine_ArtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_fine_art(inputs)
	if (locale === "es") return es_val_fine_art(inputs)
	if (locale === "fr") return fr_val_fine_art(inputs)
	if (locale === "de") return de_val_fine_art(inputs)
	if (locale === "ja") return ja_val_fine_art(inputs)
	if (locale === "zh") return zh_val_fine_art(inputs)
	if (locale === "ar") return ar_val_fine_art(inputs)
	if (locale === "id") return id_val_fine_art(inputs)
	if (locale === "it") return it_val_fine_art(inputs)
	if (locale === "ru") return ru_val_fine_art(inputs)
	if (locale === "pt") return pt_val_fine_art(inputs)
	return ko_val_fine_art(inputs)
});